import { Link } from "react-router-dom";

export default function HomeCTA() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-primary-500 rounded-2xl px-8 py-12 md:py-16 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-background-50 rounded-full -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50 rounded-full translate-y-1/3 -translate-x-1/4"></div>
          </div>
          <div className="relative z-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              准备好加入爱情岛论坛了吗？
            </h2>
            <p className="text-primary-100 text-sm md:text-base max-w-md mx-auto mb-8">
              数百万用户已经在爱情岛论坛找到了属于自己的社区。现在就加入我们，开启你的社区之旅！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/qinggan-jiaoliu"
                className="w-full sm:w-auto bg-background-50 hover:bg-background-100 text-primary-600 font-semibold px-8 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-rocket-line mr-2"></i>立即探索
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto bg-primary-600 hover:bg-primary-700 text-background-50 font-medium px-8 py-3.5 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-primary-400/30"
              >
                <i className="ri-information-line mr-2"></i>关于我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}